import { ProductService } from '@/services';
import { PaginationType, ProductType, RootModel } from '@/types';
import { createModel } from '@rematch/core';
import baseEntity from './base.entity';

interface ProductStateType {
  ids: { [id: number]: ProductType };
}

export const productEntities = createModel<RootModel>()({
  state: { ids: {} } as ProductStateType,
  reducers: {
    ...baseEntity,
  },
  effects: () => ({
    async load(payload): Promise<{ content: ProductType[] } & PaginationType> {
      const res = await ProductService.filter(payload);
      const { content } = res.data;
      if (content && content.length) {
        this.saveSimplified(content);
      }
      return res.data;
    },
    async findById(payload, state: any): Promise<ProductType> {
      const item = state.productEntities.ids[payload];
      if (item && !item.simplified) {
        return item;
      }
      const res = await ProductService.getById(payload);
      this.saves([res.data]);
      return res.data;
    },
    async delete(payload) {
      await ProductService.deleteById(payload);
      this.remove({ id: payload });
    },
    async save(payload) {
      let item;
      if (!payload.id) {
        ({ data: item } = await ProductService.create(payload));
      } else {
        ({ data: item } = await ProductService.update(payload.id, payload));
      }
      this.update(item);
      return item;
    },
    async syncProducts(payload) {
      await ProductService.syncProducts(payload);
    },
  }),
});
